import React, { Component, useEffect, lazy, Suspense } from 'react';
import Default from "../../../Layout/Default";
import { Routes, Route, Switch, } from "react-router-dom";
import { createHashHistory } from 'history';

import AppLandingPage from '../Pages/AppLandingPage';
import LoginPage from '../Pages/LoginPage';
import ForgotPassword from '../Pages/ForgotPassword';
// import logger from '../../../logger';
// import * as Store from '../../../store'
import Auth from '../../../Layout/Auth';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import TimelinePage from '../Pages/TimelinePage';
import RenewPassword from '../Pages/RenewPassword';
import UpdatePassword from '../Pages/UpdatePassword';
import NotFoundPage from '../../Utility/Pages/NotFound'
import * as Store from '../../../storeRedux'
import AccountRoute from '../../../Account/Routes/AccountRoute';
const version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? (Store.default.getState().LoginReducer.userCredentials.user_details.version).toUpperCase() : "V2";
const ChatRoute = React.lazy(() => import(`../../../${version}/Modules/ChatHistory/Routes/ChatRoute`));
const TemplateRoute = React.lazy(() => import(`../../../${version}/Modules/Template/Routes/TemplateRoute`));
import WalinerfunnelRoute from '../../../Walinerfunnel/Routes/WalinerfunnelRoute';

import HomePage from '../../../Home/Pages/HomePage';
import NotificationRoute from '../../../Notification/Routes/NotificationRoute';
import ContactManagementRoute from '../../../ContactManagement/Routes/ContactManagementRoute';


function LoginRoute(props) {
    // const history = useHistory();
    const history = createHashHistory();

    // useEffect(() => {
    //     if (props.token == "" || props.token == null) {
    //         console.loh
    //         props.history.push('/');
    //     }
    // }, [])

    return (
        <Switch>
            {/* app landing page route */}
            <Route
                exact
                path="/"
                render={() => (
                    <Default history={history}>
                        <AppLandingPage history={history} />
                    </Default>
                )}
            />

            {/* login route */}
            <Route
                exact
                path="/:lng"
                render={() => (
                    <Default history={history}>
                        <LoginPage history={history} />
                    </Default>
                )}
            />
            {/* login route */}
            <Route
                exact
                path="/:lng/login"
                render={() => (
                    <Default history={history}>
                        <LoginPage history={history} />
                    </Default>
                )}
            />

            {/* forget password route */}
            <Route
                exact
                path="/:lng/forgot_password/:type?/"
                render={() => (
                    <Default history={history}>
                        <ForgotPassword history={history} />
                    </Default>
                )}
            />


            {/* <Route
                exact
                path="/:lng/timeline"
                render={() => (
                    <Default history={history}>
                        <TimelinePage history={history} location={location} />
                    </Default>
                )}
            /> */}
            <Route
                exact
                path="/:lng/renewpassword"
                render={() => (
                    <Default history={history}>
                        <RenewPassword history={history} location={location} />
                    </Default>
                )}
            />
            <Route
                exact
                path="/:lng/updatepassword/:email/:password"
                render={() => (
                    <Default history={history}>
                        <UpdatePassword history={history} location={location} />
                    </Default>
                )}
            />

            {/* home module route */}
            <Route
                exact
                path="/:lng/home"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <HomePage history={history} />

                        </Suspense>

                    </Auth>
                )}
            />
            {/* chat module route */}
            <Route
                exact
                path="/:lng/chat/:additionalParam?"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <ChatRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* template module route */}
            <Route
                exact
                path="/:lng/template"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <TemplateRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            
            {/* contact module route */}
            <Route
                exact
                path="/:lng/contact_management"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <ContactManagementRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* account module route */}
            <Route
                exact
                path="/:lng/account"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AccountRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* notification module route */}
            <Route
                exact
                path="/:lng/notification"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <NotificationRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* CRM pipeline module route */}
            <Route
                exact
                path="/:lng/crm-pipeline"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <WalinerfunnelRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* CRM dashboard module route */}
            <Route
                exact
                path="/:lng/crm-dashboard"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <WalinerfunnelRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* CRM prospect module route */}
            <Route
                exact
                path="/:lng/prospects"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <WalinerfunnelRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* contact module route */}
            {/* <Route
                exact
                path="/:lng/integration"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <IntegrationRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            /> */}
            {/* integration module route */}
            {/* <Route
                exact
                path="/:lng/integration"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <IntegrationRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            /> */}
            {/* integration module route */}
            {/* <Route
                exact
                path="/:lng/integration_mapping/:integrationId?"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <IntegrationRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            /> */}
            {/* app create module route */}
            {/* <Route
                exact
                path="/:lng/app-create"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AppCreateRoute history={history} />
                        </Suspense>

                    </Auth>
                )}
            /> */}

        </Switch>
    );

}

function Loading() {
    return (
        <>
            <div className="wrapperContainer">
                <LoadingOverlay
                    active={true}
                    className='lodingOverlayDivContainer'
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: 'rgba(255, 255, 255, 0.1)',
                            zIndex: '9999999999999'
                        })
                    }}
                ></LoadingOverlay>
            </div>
        </>
    );
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        accessToken: globalState.LoginReducer.accessToken,
        token: globalState.LoginReducer.token,
        leftbar: globalState.mainReducerData.leftbar,
    };
}

export default connect(mapStateToProps)(withRouter(LoginRoute));
// export default LoginRoute;
